import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { getDesignToken } from 'styles/constants';

export const Wrapper = ({ children }: React.PropsWithChildren) =>
  React.createElement(Box, { style: styles.wrapper }, children);

export const Message = ({ children }: React.PropsWithChildren) =>
  React.createElement(Typography, { style: styles.message }, children);

export const MessageIcon = Icon.withConfig({
  color: getDesignToken('text-default'),
});

const styles = StyleSheet.create({
  wrapper: { alignItems: 'center', flexDirection: 'row', marginBottom: 4 },
  message: {
    color: getDesignToken('text-default'),
    fontSize: 12,
    marginLeft: 1.5,
    textTransform: 'capitalize',
  },
});
